import React from 'react'
import { ExportCircleWiseReport } from './ExportCircleWiseReport';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTripStore } from '../../../store/useTripStore';
import MUITable from '../../../../../../Common/MUITable';
import Loader from '../../../../../../Common/Loader/loader';
import { formatDateTimeWithoutSec, getCurrentDateTime1 } from '../../../../../../Common/helper/helpar';

const SATZoneInnerCircleReport = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  console.log(state)
  const {
    isFetchingCircleWiseTrips,
    circleWiseTrips,
    fetchTripDetails,
    fetchCircleWiseTrips,
    fetchTotalTripDetails
  } = useTripStore();

  const filters = JSON.parse(localStorage.getItem("sat-trips-zone-filters"));

  const circleWiseHeaderColumns = [
    {
      label: "Circle",
      field: "circleName",
      render: (row) => (
        <div
        // style={{
        //   cursor: `${row.circleName === "Total" ? "initial" : "pointer"}`,
        //   color: `${row.circleName === "Total" ? "black" : "blue"}`,
        // }}
          // onClick={() => {
          //   const params = {
          //     ...filters,
          //     // ZoneId: row.circleName === "Total" ? "" : row.zoneId,
          //     CircleId: row.circleName === "Total" ? "" : row.circleId,
          //   }
          //   if (row.circleName !== "Total") {
          //     fetchCircleWiseTrips(params)
          //     navigate("/sat-inner-circle-zone-report", { state: { ...filters, colName: "Reported at TS/SCTP", circleName: row.circleName, zoneName: row.zoneName } })  
          //   }
            
          // }}
        >
          {row.circleName}
        </div>
      ),

    },
    {
      label: "Reported at TS/SCTP",
      field: "reportedatTSSCTP",
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "5",
              isUnique: true,
              ZoneId: state.zoneId,
              CircleId: row.circleName === "Total" ? "" : row.circleId,
            }
            fetchTripDetails(params)
            navigate("/sat-inner-trip-report", { state: { ...filters, colName: "Reported at TS/SCTP", circleName: row.circleName } })
          }}
        >
          {row.reportedatTSSCTP}
        </div>
      ),
    },
    {
      label: "Total Trips",
      field: "totalTrips",
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "5",
              isUnique: false,
              ZoneId: state.zoneId,
              CircleId: row.circleName === "Total" ? "" : row.circleId,
            }
						fetchTripDetails(params)
            navigate("/sat-total-inner-trip-report", { state: { ...filters, colName: "Total Trips", circleName: row.circleName } })
          }}
        >
          {row.totalTrips}
        </div>
      ),
    },
    {
      label: "1 Trip",
      field: "oneTrip",
      sortable: true,
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "1",
              ZoneId: state.zoneId,
              CircleId: row.circleName === "Total" ? "" : row.circleId,
            }
            fetchTripDetails(params)
            navigate("/sat-inner-trip-report", { state: { ...filters, colName: "1 Trip", circleName: row.circleName } })
          }}
        >
          {row.oneTrip}
        </div>
      ),
    },
    {
      label: "2 Trips",
      field: "twoTrips",
      sortable: true,
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "2",
              ZoneId: state.zoneId,
              CircleId: row.circleName === "Total" ? "" : row.circleId,
            }
            fetchTripDetails(params)
            navigate("/sat-inner-trip-report", { state: { ...filters, colName: "2 Trips", circleName: row.circleName } })
          }}
        >
          {row.twoTrips}
        </div>
      ),
    },
    {
      label: "3 Trips",
      field: "threeTrips",
      sortable: true,
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "3",
              ZoneId: state.zoneId,
              CircleId: row.circleName === "Total" ? "" : row.circleId,
            }
            fetchTripDetails(params)
            navigate("/sat-inner-trip-report", { state: { ...filters, colName: "3 Trips", circleName: row.circleName } })
          }}
        >
          {row.threeTrips}
        </div>
      ),
    },
    {
      label: "Above 4 Trips",
      field: "above4Trips",
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "4",
              ZoneId: state.zoneId,
              CircleId: row.circleName === "Total" ? "" : row.circleId,
            }
            fetchTripDetails(params)
            navigate("/sat-inner-trip-report", { state: { ...filters, colName: "Above 4 Trips", circleName: row.circleName } })
          }}
        >
          {row.above4Trips}
        </div>
      ),
    },
    {
      label: "Quantity in MT(Est)",
      field: "quantityinMTEst",
      render: row => row.quantityinMTEst,
    },
  ];

  return (
    <div className="content">
      <div className="page-content">
        <div className="page-header">
          <div className="card mt-3">
            <div className="">
              {isFetchingCircleWiseTrips && <Loader />}
              <div class="d-flex justify-content-end mt-3 mb-3">
                <button
                  class="btn btn-secondary  me-2"
                  type="button"
                  onClick={() => navigate(-1)}
                >
                  Back
                </button>
                <ExportCircleWiseReport data={state} />
              </div>
              <div className="top-header">
                <span>{state.zoneName} Zone, Circles wise SATs Trips to TS/SCTP ({formatDateTimeWithoutSec(state.FromDateTime)} To {formatDateTimeWithoutSec(state.ToDateTime)}) (at {getCurrentDateTime1()})</span>
              </div>
              <MUITable
                needSRNumber
                hasTotalRow={true}
                columns={circleWiseHeaderColumns}
                rows={circleWiseTrips}
                tableHeight={500}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SATZoneInnerCircleReport;